import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

const LOCALSTRKEY = 'LIVE_GIFT_BANNER';

export interface msgListJson {
  classname?: string;
  status?: number;
  nickName?: string;
  msg?: string;
  icon?: string;
  giftIcon?: string;
  animation_file?: string;
  animation_type?: string;
  balance?: number;
  combo_num?: any;
  count?: string;
  full_screen?: string;
  full_effect_url?: string;
  gift_icon?: string;
  gift_id?: number;
  gift_name?: string;
  head_img?: string;
  nickname?: string;
  uid?: number;
  scene_id?: number;
  scene_type?: number;
  t_head_img?: string;
  t_nickname?: string;
  t_uid?: number;
  from?: string;
  to?: number;
  mid?: number;
  time?: number;
  isPlay: boolean;
  visible?: boolean;
}

export interface GiftBannerInfoJson {
  giftItem: msgListJson;
}

const localGameInfo = LocalStore.getValue<GiftBannerInfoJson>(LOCALSTRKEY) || {};

export const giftBannerInfo: GiftBannerInfoJson = {
  giftItem: {
    isPlay: false
  },
  ...localGameInfo
};

export const setGiftBannerInfo: (payload: GiftBannerInfoJson) => IAction<GiftBannerInfoJson> = (
  payload: GiftBannerInfoJson
) => ({
  type: 'setGiftBannerInfo',
  payload
});

const giftBannerReducer: Reducer<GiftBannerInfoJson, IAction<any>> = (state = giftBannerInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setGiftBannerInfo':
      LocalStore.setValue(LOCALSTRKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default giftBannerReducer;
